import React, { useCallback, useContext, useEffect, useState } from "react";
import { DropDownOptions, IProjectModel, ProjectTypeEnum, ThemeTypes } from "../../models/SharedModel";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import { ProjectStatus } from "../../models/ProjectModel";
import ProjectCard from "./ProjectCard";
import { useNavigate, useParams } from "react-router-dom";
import { getFromSession, pastDays, setToSession, text_convert_lower } from "../../helpers/GenericHelpers";
import { v4 as uuid } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEllipsisVertical, faPlus, faXmark } from "@fortawesome/free-solid-svg-icons";
import { RoutesEnum } from "../../models/RoutesModel";
import Service from "../../services";
import { ThemeContext } from "../../models/ThemeContext";
import userDark from '../../images/user-dark.png';
import plusDark from '../../images/plus-dark.png';
import historyDark from '../../images/darkLeftBarIcons/historyDark.png'
import documentAIService from "../../projects/document_ai/documentAIService";

interface IProjectListProps {
  projectList: IProjectModel[];
  selectedProject: IProjectModel | null;
  setSelectedProject: React.Dispatch<React.SetStateAction<IProjectModel | null>>;
  toggleNewModal?: () => void;
  toggleLogsModal?: () => void;
  toggleAddWorkSpaceModal: Function;
  workSpaceData?: any;
  setWorkSpaceData: Function;
  toggleMapWorkSpaceModal: Function;
  setSelectedWorkSpace: Function;
  selectedWorkSpace: any;
  leftNavigationTab?: any;
  get_project_list?: Function;
}

const filterValues = [
  // {
  //   filterId: uuid(),
  //   label: 'Flagged',
  //   value: false,
  //   checkValue: (value: IProjectModel) => (value?.flag_count || 0) > 0,
  // },
  // {
  //   filterId: uuid(),
  //   label: text_convert_lower(ProjectTypeEnum.DATA_ANALYTICS),
  //   value: false,
  //   checkValue: (value: IProjectModel) => value?.project_type?.match(ProjectTypeEnum.DATA_ANALYTICS),
  // },
  {
    filterId: uuid(),
    label: text_convert_lower(ProjectTypeEnum.DOCUMENT_AI),
    value: false,
    checkValue: (value: IProjectModel) => value?.project_type?.match(ProjectTypeEnum.DOCUMENT_AI),
  },
  {
    filterId: uuid(),
    label: text_convert_lower(ProjectTypeEnum.RESEARCH_INSIGHTS),
    value: false,
    checkValue: (value: IProjectModel) => value?.project_type?.match(ProjectTypeEnum.RESEARCH_INSIGHTS),
  },
  // {
  //   filterId: uuid(),
  //   label: text_convert_lower(ProjectTypeEnum.EBOOK__INSIGHTS),
  //   value: false,
  //   checkValue: (value: IProjectModel) => value?.project_type?.match(ProjectTypeEnum.EBOOK__INSIGHTS),
  // },
]

const ProjectList = (props: IProjectListProps) => {

  const { themeName } = useContext(ThemeContext);
  const { projectList, workSpaceData, setWorkSpaceData, selectedProject, leftNavigationTab, setSelectedProject, toggleNewModal, toggleLogsModal, toggleAddWorkSpaceModal, toggleMapWorkSpaceModal, setSelectedWorkSpace, get_project_list } = props;
  const navigate = useNavigate();
  const { tab } = useParams()

  // states
  const [projectTab, setProjectTab] = useState(tab || ProjectStatus.DRAFT);
  const [optionsDropdown, setOptionsDropdown] = useState('');
  const [workSpaceoptionsDropdown, setWorkSpaceOptionsDropdown] = useState('');
  const [filters, setFilters] = useState(filterValues)

  useEffect(()=>{
    console.log('test theme name   ' + themeName)
  },[themeName])

  // helpers
  const projectRedirection = (project: IProjectModel) => {
    navigate(`/${project.project_name}/${project.project_type}/${project?.version || 0.1}`);
    setToSession('project_main', JSON.stringify(project))
  }

  const toggleOptionsDropdown = (e: any, value: string) => {
    e?.stopPropagation();
    setOptionsDropdown(prev => prev === value ? '' : value)
  }

  // workspace toggle dropdown
  const toggleWorkspaceOptionsDropdown = (e: any, value: string) => {
    e?.stopPropagation();
    setWorkSpaceOptionsDropdown(prev => prev === value ? '' : value)
  }

  const dropDownSelection = (type: DropDownOptions, project: IProjectModel) => {
    if (type === DropDownOptions.NEW_VERSION) {
      // new version 
      setSelectedProject(project)
      toggleNewModal && toggleNewModal()
    }
    if (type === DropDownOptions.VIEW_LOGS) {
      // logs
      setSelectedProject(project)
      console.log(type, project)
      toggleLogsModal && toggleLogsModal()
    }
    if (type === DropDownOptions.ASSIGN_WORK_SPACE) {
      console.log(type, project)
    }
  }

  const changeFilters = (filter: any) => {
    setFilters(prev => prev?.map(each => each?.filterId === filter?.filterId ? { ...each, value: !each?.value } : each))
  }

  const getFilteredValues = (project: IProjectModel) => {
    const activeFilters = filters?.filter(each => each?.value)
    if (activeFilters?.length > 0) {
      return activeFilters?.every(fill => fill?.checkValue(project))
    } else return true
  }

  // This is for blue and dark theme setup for navigation bar and the left bar
  useEffect(() => {
    if (themeName === ThemeTypes?.BLUE_THEME || themeName === ThemeTypes?.DARK_THEME) {
      setProjectTab(leftNavigationTab)
    }
  }, [leftNavigationTab])
  // display components
  const displayTabs = () => {
    const keys = Object.keys(ProjectStatus);
    return keys?.map((each) => {
      const value = (ProjectStatus as any)?.[each];
      return (
        <NavItem key={each}>
          <NavLink
            className={projectTab === value ? "active" : ""}
            onClick={() => {
              navigate(`${RoutesEnum.LANDING}/${value}`)
              setProjectTab(value)
            }}
          >
            {value}
          </NavLink>
        </NavItem>
      );
    });
  };

  const displayTabContent = useCallback(() => {
    const keys = Object.keys(ProjectStatus);
    return keys?.map((each) => {
      const value = (ProjectStatus as any)?.[each];
      const filteredProjects = projectList?.filter(proj => {
        return getFilteredValues(proj)
      })?.filter(
        (each) => each?.project_status === value
      );
      return (
        <TabPane key={value} tabId={value}>
          <div className="project-list-main">
            {filteredProjects && filteredProjects?.length > 0 ? (
              filteredProjects?.map((project) => (
                <ProjectCard
                  project={project}
                  handleClick={projectRedirection}
                  optionsDropdown={optionsDropdown}
                  toggleOptionsDropdown={toggleOptionsDropdown}
                  dropDownSelection={dropDownSelection}
                  workSpaceData={workSpaceData}
                  toggleAddWorkSpaceModal={toggleAddWorkSpaceModal}
                  setSelectedProject={setSelectedProject}
                  get_project_list={get_project_list}
                />
              ))
            ) : (
              <div className="not-found">No records available</div>
            )}
          </div>
        </TabPane>
      );
    });
  }, [projectList, filters, optionsDropdown, workSpaceData, themeName])

  const [projectShowAndHide, setProjectShowAndHide] = useState<boolean>(true);
  const [workspaceProjectData, setWorkspaceProjectData] = useState<[]>();
  const [workspaceProjectName, setWorkspaceProjectName] = useState();
  const gotoWorkSpaceProjects = (dataFlip: boolean, projectData: any, workspace_name?:any) => {
    setProjectShowAndHide(dataFlip);
    setWorkspaceProjectData(projectData);
    setWorkspaceProjectName(workspace_name);
  }

  const workSpaceSetup = (e:any,ele: any) => {
    e?.stopPropagation();
    toggleMapWorkSpaceModal();
    setSelectedWorkSpace(ele)
  }
  const workSpace = useCallback(() => {
    return (
      <div>
        <TabPane>
          {projectShowAndHide ? <div className="project-list-main">
            {workSpaceData && workSpaceData?.length > 0 ? (
              workSpaceData?.map((ele: any) => (
                <div className='proj-main-card work-space' onClick={() => gotoWorkSpaceProjects(false, ele?.workspace_projects, ele?.workspace_name)}>
                  <div className="proj-title-main">
                    <div className="project-left">
                      <div className="proj-name">{ele?.workspace_name || "--"}</div>
                    </div>
                    <div className="proj-menu">
                      <div className="proj-options">
                        <Dropdown
                          // Todo: change its project id
                          isOpen={workSpaceoptionsDropdown === ele?.workspace_id}
                          toggle={(e: any) => toggleWorkspaceOptionsDropdown(e, ele?.workspace_id)}
                        >
                          <DropdownToggle>
                            <FontAwesomeIcon icon={faEllipsisVertical} />
                          </DropdownToggle>
                          <DropdownMenu>
                            <DropdownItem
                              onClick={(e:any) => workSpaceSetup(e,ele)}
                            >
                              Access to User
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                  <div className="pro-details">
                    <div className="image-stack" onClick={(e:any) => workSpaceSetup(e,ele)}>
                      <img src={plusDark} alt="plus" />
                      <img src={userDark} alt="user" />
                    </div>
                    <div className="right">
                      <img src={historyDark} />
                      <div className="days">12 Jan</div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="not-found">No workspace records available</div>
            )}
          </div> :
            <>
              <div className="workspace-title">
                <FontAwesomeIcon icon={faArrowLeft} onClick={() => gotoWorkSpaceProjects(true, [])} />
                <div className="title">{workspaceProjectName}</div>
              </div>
              {<>
                <div className="project-list-main">
                  {workspaceProjectData && workspaceProjectData?.length > 0 ? (
                    workspaceProjectData?.map((pro: any) => (
                      <>
                        <ProjectCard
                          project={pro[0]}
                          handleClick={projectRedirection}
                          optionsDropdown={optionsDropdown}
                          toggleOptionsDropdown={toggleOptionsDropdown}
                          dropDownSelection={dropDownSelection}
                          workSpaceData={workSpaceData}
                          toggleAddWorkSpaceModal={toggleAddWorkSpaceModal}
                          setSelectedProject={setSelectedProject}
                          get_project_list={get_project_list}
                        />
                      </>
                    ))
                  ) : (
                    <div className="not-found">No records available</div>
                  )}
                </div>
              </>}
            </>}
        </TabPane>
      </div>
    )
  }, [projectList, filters, projectShowAndHide, workSpaceData, optionsDropdown, workSpaceoptionsDropdown, workspaceProjectData])
  return (
    <div className="projects-main">
      <div className="project-nav">
        {/* {themeName === ThemeTypes?.BLUE_THEME ? <Nav pils>{displayTabs()}</Nav> : null} */}
        <div className="filters">
          <div className="filter-text">Filters</div>
          <div className="filter-list">
            {filters?.map(each =>
              <div
                key={each?.filterId}
                className={`filter-item ${each?.value ? 'active' : ''}`}
                onClick={() => !each?.value && changeFilters(each)}
              >{each?.label}{each?.value ? <span className="filter-close" onClick={() => changeFilters(each)}>
                <FontAwesomeIcon icon={faXmark} />
              </span> : <></>}</div>
            )}
          </div>
        </div>
      </div>
      <TabContent activeTab={projectTab}>

        {(projectTab !== ProjectStatus.WORK_SPACE) ? displayTabContent() : workSpace()}

      </TabContent>

    </div>
  );
};

export default ProjectList;
